import axios from 'axios'
import myaxios from './axios.service'

import CompanyTool from '../tools/CompanyTool'
import CryptoTool from '../tools/CryptoTool'


import env from '@/../.env'
import eventHub from '@/eventHub'

function convertObjToFormData(keyname, obj)
{
    var formData = new FormData();

    // Convert all parameters to formData
    for (var key in obj) {
        formData.append(key, obj[key]);
    }

    // Connect to the API
    formData.append('operation', keyname)
    formData.append('id', env.API_ID)
    formData.append('token', env.API_TOKEN)

    // Send language
    let lang = 'FR'
    
    if (localStorage.getItem('langage')) {
        if (localStorage.getItem('langage') == 'fr-FR') {
            lang = 'FR'
        } else {
            lang = localStorage.getItem('langage')
        }
    }
    formData.append('langue', lang)

    // Send DomainName
    let domainName = CompanyTool.confFile() ? CompanyTool.confFile().api_keyname : null
    if (domainName) {
        formData.append('domain_name', domainName)
    }

    return formData
}

const ApiService = {
    demoSpace: function () {
        const configFile = CompanyTool.confFile()
        if (configFile && configFile.demo) {
            return true
        }
        return false
    },

    refreshApiToken: async function(apiUrl) {
        var formData = new FormData();
        formData.append('action', 'refresh_tokenAPI')
        formData.append('id', '777')
        formData.append('token', env.PRIVATE_API_TOKEN_KEY)

        let responseToken = await myaxios(apiUrl).post('', formData)
        localStorage.setItem('api-token', responseToken.data.posts.post)
    },

    sendRequest: async function (url, keyname, obj) {
        // Init data
        let isValid = false
        let response = null
        let tests = 0

        while (!isValid && tests++ < 10) {
            // Get response data
            response = await myaxios(url).post('', convertObjToFormData(keyname, obj))

            // Refresh token
            if (response.data.posts.error == 'token expire' || response.data.posts.error == 'Authentification Failed') {
                await this.refreshApiToken(url)
            } else {
                // break while
                isValid = true

                // Display error toast
                if (response.data.posts && response.data.posts.error && response.data.posts.error != 0) {
                    eventHub.$emit('toast-error', response.data.posts.error)
                }
            }
        }
        return response
    },

    post: async function (keyname, obj, apiName = 'api') {
        let apiUrl = null
        if (apiName == 'api') {
            apiUrl = this.getUrl()
        }
        if (apiName == 'api2') {
            apiUrl = env.API2_URL
        }
        if (!apiUrl) {
            apiUrl = this.getUrl()
        }
        return await this.sendRequest(apiUrl, keyname, obj)
    },

    postProd: async function (keyname, obj) {
        // return await myaxios.post(env.API_URL, convertObjToFormData(keyname, obj))
        return await this.sendRequest(env.API_URL, keyname, obj)
    },

    onDemo: function() {
        let currentDomainName = window.location.hostname
        const demoUrls = ['localhost', 'savlog.3w-dev.com', 'demo.savlog.net']

        return CompanyTool.demoSpace() || window.localStorage.getItem('env-unit-test') || demoUrls.includes(currentDomainName)
    },

    getUrl: function() {
        let url = env.API_URL

        if (this.onDemo()) {
            url = env.DEMO_API_URL
        }
        return url
    },

    getUser: async function() {
        let client_id = CryptoTool.decrypt(localStorage.getItem('client_id'))
        let result = null
        if (client_id) {
            let response = await this.sendRequest(this.getUrl(), 'get_conso', {id_conso: client_id})
            if (response.data.posts) {
                result = response.data.posts.post
            }
            result.id = CryptoTool.decrypt(localStorage.getItem('client_id'))
        }
        return result
    },

    text: async function(keyname, id_proc, id_case = null) {
        let responseText = await this.post('get_text', {
            id_case: id_case,
            id_proc: id_proc,
            keyname: keyname
        })
        return responseText.data.posts.post
    }
}
export default ApiService



// WEBPACK FOOTER //
// ./src/services/api.service.js